import { useEffect, useState } from "react";
import { FinanceAllocationRule } from "@features/admin/finance/allocation-rule/types/financeAllocationRule";
import { FinanceAllocationRuleQueryParams } from "@features/admin/finance/allocation-rule/types/financeAllocationRuleQueryParams";
import { fetchFinanceAllocationRulesAsync } from "@features/admin/finance/allocation-rule/services/financeAllocationRuleSvc";
import { normalizeAllForList } from "@core/utils/listQuery";

export function useFinanceAllocationRule(
    params: FinanceAllocationRuleQueryParams,
    options: { enabled?: boolean } = { enabled: true }
) {
    const [current_page, setCurrentPage] = useState(params.page || 1);
    const [data, setData] = useState<FinanceAllocationRule[]>([]);
    const [first_page_url, setFirstPageUrl] = useState<string | undefined>(undefined);
    const [from, setFrom] = useState<number | undefined>(undefined);
    const [last_page, setLastPage] = useState<number | undefined>(undefined);
    const [last_page_url, setLastPageUrl] = useState<string | undefined>(undefined);
    const [links, setLinks] = useState<{ url: string | null; label: string; active: boolean }[] | undefined>(undefined);
    const [next_page_url, setNextPageUrl] = useState<string | null | undefined>(undefined);
    const [path, setPath] = useState<string | undefined>(undefined);
    const [per_page, setPerPage] = useState<number | undefined>(undefined);
    const [prev_page_url, setPrevPageUrl] = useState<string | null | undefined>(undefined);
    const [to, setTo] = useState<number | undefined>(undefined);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);

    const reload = async () => {
        setLoading(true);
        if (!options?.enabled) return;
        try {
            const { nationId, ...rawFetchParams } = params;
            const fetchParams = normalizeAllForList(rawFetchParams, ["freetext", "isActive", "kpiId"]);
            const response = await fetchFinanceAllocationRulesAsync(nationId, fetchParams);
            if (response) {
                setCurrentPage(response.getData()?.current_page || 1);
                setData(response.getData()?.data || []);
                setFirstPageUrl(response.getData()?.first_page_url);
                setFrom(response.getData()?.from);
                setLastPage(response.getData()?.last_page);
                setLastPageUrl(response.getData()?.last_page_url);
                setLinks(response.getData()?.links);
                setNextPageUrl(response.getData()?.next_page_url);
                setPath(response.getData()?.path);
                setPerPage(response.getData()?.per_page);
                setPrevPageUrl(response.getData()?.prev_page_url);
                setTo(response.getData()?.to);
                setTotal(response.getData()?.total || 0);
            }
        } finally {
            setLoading(false);
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { reload(); }, [
        params.nationId, params.page, params.all,
        params.freetext, params.isActive, params.kpiId,
        options.enabled,
    ]);

    return {
        current_page, data, first_page_url, from, last_page, last_page_url,
        links, next_page_url, path, per_page, prev_page_url, to, total,
        loading, reload,
    };
}
